
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { ReasonModel } from 'models/generated/Entities.GormCrm.Reason';
import { ReasonCategoryModel } from 'models/generated/Entities.GormCrm.ReasonCategory';


const _gormCrm_ReasonControllerHelper = new Map<string, Object>();
_gormCrm_ReasonControllerHelper.set('GetAllReasons', ReasonModel);
_gormCrm_ReasonControllerHelper.set('GetAllReasonCategories', ReasonCategoryModel);
_gormCrm_ReasonControllerHelper.set('CreateReasons', ReasonModel);
_gormCrm_ReasonControllerHelper.set('CreateReasonCategory', ReasonCategoryModel);
_gormCrm_ReasonControllerHelper.set('UpdateReason', ReasonModel);
_gormCrm_ReasonControllerHelper.set('UpdateReasonCategory', ReasonCategoryModel);


export const gormCrm_ReasonControllerHelper = _gormCrm_ReasonControllerHelper;

